// components/auth/ProtectedRoute.tsx

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  // Auth is optional - always allow access for now
  return <>{children}</>;
}
